import React from "react";

// BSU uses Zendesk so this is just a fallback
export default function HelpContent() {
    return (
        <div>
            For help, contact{" "}
            <a href="mailto:placement@byui.edu">placement@byui.edu</a>
        </div>
    );
}



// WEBPACK FOOTER //
// ./src/siteConfig/sites/byui/siteComponents/helpContent.js